export default __webpack_public_path__ + "static/media/logo.1524c533.png";